import React from "react";
import { Box, Typography } from "@mui/material";
import { AccessibilityStatus } from "@/types/common";
import { FONT_SIZES } from "@/shared/constants/typography";
import { ACCESSIBILITY_STATUS_CONFIG } from "@/shared/constants/accessibility";

export interface AccessibilityChipProps {
  status: AccessibilityStatus;
}

const AccessibilityChip: React.FC<AccessibilityChipProps> = ({
  status,
}) => {
  const config = ACCESSIBILITY_STATUS_CONFIG[status] || ACCESSIBILITY_STATUS_CONFIG.no_data;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        bgcolor: config.bg,
        border: `1px solid ${config.dot}`,
        borderRadius: "6px",
        p: "1.2%",
        width: "fit-content",
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: config.dot,
          mr: 0.8,
        }}
      />
      <Typography
        sx={{
          fontSize: FONT_SIZES.CAPTION,
          textWrap: "nowrap",
        }}
      >
        {config.label}
      </Typography>
    </Box>
  );
};

export default AccessibilityChip;
